import React from "react";

const FooterButton = (props) => {
    const {isMobileView,buttonText,onClick,isDisabled=false}=props;
  return (
    <div className="inner-layout-footer-new">
      <div className="inner-btm-fixed-nav">
        <div className="btn-wrap text-center pb-0 pt-0">
          <button
            type="button"
            className={`btn btn-primary mb-3 ${isMobileView ? 'w-100' : 'w-25'}`}
            disabled={isDisabled}
            onClick={onClick}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FooterButton;
